export const formatRHValue = (value, fallback = '-') => {
  if (value === undefined || value === null || value === '') return fallback;
  if (Array.isArray(value)) return value.length ? value.filter(Boolean).join(', ') : fallback;
  return value;
};

export const getRHUserValue = (user = {}, ...keys) => {
  const source = user || {};
  for (const key of keys) {
    if (source[key] !== undefined && source[key] !== null && source[key] !== '') return source[key];
  }
  return '';
};

export const getRHUserName = (user = {}) => {
  const source = user || {};
  const directName = getRHUserValue(source, 'name', 'fullName', 'full_name');
  if (directName) return directName;
  return [getRHUserValue(source, 'firstName', 'first_name'), getRHUserValue(source, 'lastName', 'last_name')]
    .filter(Boolean).join(' ') || 'Collaborateur';
};

export const getRHInitials = (user = {}) => getRHUserName(user)
  .split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]?.toUpperCase()).join('');

export const formatRHDate = (value, fallback = '-') => {
  if (!value) return fallback;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : new Intl.DateTimeFormat('fr-FR').format(date);
};

export const formatRHDateRange = (start, end) => {
  if (!start) return '-';
  return end ? `${formatRHDate(start)} – ${formatRHDate(end)}` : formatRHDate(start);
};

export const formatRHDuration = (days) => days === undefined || days === null ? '-' : `${days} j`;


// Absences are calendar dates; compare against today's date in the ERP timezone.
export const selectNextRHAbsence = (requests = [], now = new Date()) => {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
  const today = ['year', 'month', 'day'].map(type => parts.find(part => part.type === type).value).join('-');
  const dateKey = item => String(getRHUserValue(item, 'startDate', 'start_date', 'date_debut')).slice(0, 10);
  return requests.filter(item => {
    const day = dateKey(item);
    const parsed = new Date(`${day}T12:00:00Z`);
    const valid = /^\d{4}-\d{2}-\d{2}$/.test(day) && !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === day;
    const status = String(item.status || 'pending').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase().replaceAll('_', ' ');
    return valid && day >= today && ['approved', 'pending', 'approuvee', 'approuve', 'en attente'].includes(status);
  }).sort((left, right) => dateKey(left).localeCompare(dateKey(right)))[0] || null;
};


export const formatRHAbsenceStatus = (status = '') => ({ pending: 'En attente', approved: 'Approuvée', rejected: 'Refusée', refused: 'Refusée', cancelled: 'Annulée' }[String(status).toLowerCase()] || status);

const translatedRHCode = (value, labels) => { const key = String(value ?? '').trim().toLowerCase(); return Object.hasOwn(labels, key) ? labels[key] : value; };
export const formatRHStatus = value => translatedRHCode(value, {
  pending: 'En attente', requested: 'Demandé', valid: 'Valide', expired: 'Expirée', renewal_due: 'À renouveler', revoked: 'Révoquée',
  approved: 'Approuvé', rejected: 'Refusé', refused: 'Refusé', cancelled: 'Annulé', planned: 'Planifié', in_progress: 'En cours', completed: 'Terminé',
  available: 'Disponible', unavailable: 'Indisponible', missing: 'Manquant', draft: 'Brouillon', generated: 'Généré', archived: 'Archivé',
  failed: 'Échec', error: 'Erreur', active: 'Actif', inactive: 'Inactif', to_validate: 'À valider',
});
export const formatRHConfidentiality = value => translatedRHCode(value, {
  public: 'Publiable', internal: 'Interne', confidential: 'Confidentiel', private: 'Privé', personal: 'Personnel', restricted: 'Restreint',
});
export const formatRHCertificationType = value => translatedRHCode(value, {
  other: 'Autre', certification: 'Certification', qualification: 'Qualification', authorization: 'Habilitation', habilitation: 'Habilitation',
  electrical: 'Habilitation électrique', electrical_habilitation: 'Habilitation électrique', fire_safety: 'Sécurité incendie', safety: 'Sécurité', irve: 'IRVE', ssi: 'SSI',
});
